import React from "react";
import PropTypes from "prop-types";

import "./style.scss";

export function Seperation(props) {
  const className = `mc_timer_seperator ${props.className}`;

  return <span className={className}>:</span>;
}

Seperation.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
};

Seperation.defaultProps = {
  className: "",
};
